"use client";

import { Core } from "@faire/design-tokens";
import React from "react";

import { createSVGIcon } from "../util";

/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1791))
 * @trackcomponent
 * @lastsynced 2023-07-10T21:44:59.602Z
 */
export const Euro = createSVGIcon(
  <>
    <path
      d="M0.5 12.5C0.5 15.6826 1.76428 18.7348 4.01472 20.9853C6.26516 23.2357 9.3174 24.5 12.5 24.5C15.6826 24.5 18.7348 23.2357 20.9853 20.9853C23.2357 18.7348 24.5 15.6826 24.5 12.5C24.5 9.3174 23.2357 6.26516 20.9853 4.01472C18.7348 1.76428 15.6826 0.5 12.5 0.5C9.3174 0.5 6.26516 1.76428 4.01472 4.01472C1.76428 6.26516 0.5 9.3174 0.5 12.5V12.5Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.25 11.2052C7.25 11.4755 7.46913 11.6946 7.73945 11.6946H8.44831V13.0111H7.73945C7.46914 13.0111 7.25 13.2302 7.25 13.5005C7.25 13.7708 7.46914 13.99 7.73945 13.99H8.49894C8.80274 16.606 10.4567 18.4963 13.039 18.4963C15.1363 18.4963 16.64 17.3228 17.1283 15.2894C17.2243 14.8894 16.8994 14.5301 16.488 14.5301C16.1452 14.5301 15.8603 14.7837 15.7715 15.1148C15.3851 16.5546 14.4311 17.298 13.039 17.298C11.1994 17.298 10.1698 16.0659 9.95042 13.99H12.9375C13.1726 13.99 13.3745 13.8228 13.4184 13.5917C13.4755 13.2902 13.2444 13.0111 12.9375 13.0111H9.89979V11.6946H13.3763C13.6114 11.6946 13.8134 11.5274 13.8572 11.2964C13.9144 10.9949 13.6832 10.7157 13.3763 10.7157H9.93354C10.1529 8.62289 11.1994 7.27268 13.0053 7.27268C14.3003 7.27268 15.236 7.97841 15.6111 9.23324C15.7101 9.56454 15.9959 9.8212 16.3416 9.8212C16.758 9.8212 17.0864 9.45545 16.9798 9.05293C16.488 7.19439 15.0503 6.125 13.0053 6.125C10.3386 6.125 8.76899 8.13344 8.49894 10.7157H7.73945C7.46914 10.7157 7.25 10.9349 7.25 11.2052Z"
      fill="currentColor"
    />
  </>,
  "Euro",
  { viewBox: "0 0 25 25", fill: "none", color: Core.icon.default } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
